// @flow

import React from 'react';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import { Box, Button, Touchable } from 'gestalt';

type HoverHandler = () => void;
type Props = {
  email: ?boolean,
  inviteQueue?: { [string]: string },
  id: string,
  is_pinner: ?boolean,
  label: ?string,
  onClick: ({
    event: SyntheticMouseEvent<HTMLDivElement> | SyntheticKeyboardEvent<HTMLDivElement>,
  }) => void,
  onHoverEnd: HoverHandler,
  onHoverStart: HoverHandler,
  send_pin_image: ?string,
  type: 'user' | 'facebook_non_pinner' | 'gplus_non_pinner',
};

export default function SendToUser({
  email,
  inviteQueue,
  id,
  is_pinner,
  label,
  onClick,
  onHoverEnd,
  onHoverStart,
  send_pin_image,
  type,
}: Props) {
  const buttonProps = {
    text: i18n._('Add', 'Add board collaborator invite'),
    color: 'red',
    size: 'sm',
  };
  if (inviteQueue && inviteQueue[id]) {
    buttonProps.text = i18n._('Remove', 'Remove a board collaborator invite');
    buttonProps.color = 'gray';
  }
  let title = i18n._('Enter an email address');
  if (is_pinner) {
    title = i18n._('On Pinterest');
  } else if (email) {
    title = email;
  } else if (type === 'facebook_non_pinner') {
    title = i18n._('Facebook');
  } else if (type === 'gplus_non_pinner') {
    title = i18n._('Google');
  }
  return (
    <Touchable onMouseEnter={onHoverStart} onMouseLeave={onHoverEnd} onTouch={onClick}>
      <Box position="relative">
        {send_pin_image ? (
          <span className="typeaheadImg">
            <img alt="" src={send_pin_image} />
          </span>
        ) : null}
        <p className={cx('typeaheadName', { hasImage: send_pin_image })}>{label}</p>
        <div className="titleWrapper">
          <i
            className={cx(
              'titleIcon',
              { isPinner: is_pinner },
              { isFacebook: type === 'facebook_non_pinner' },
              { isGplus: type === 'gplus_non_pinner' },
            )}
          />
          <p className="title">{title}</p>
        </div>
        <Box top right position="absolute" width={90}>
          {inviteQueue && <Button {...buttonProps} />}
        </Box>
      </Box>
    </Touchable>
  );
}
